import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ConsensusSummaryDataService {
  selectedConsensusDistribution$ = new BehaviorSubject(-1);
  baseUrl = `${window.apiUrl}/tpr_page`;

  constructor(private http: HttpClient) {}

  setSelectedConsensusDistribution = (id) => {
    this.selectedConsensusDistribution$.next(id);
  };

  getTprConsensusSummary = (ticker: string): Observable<any> => {
    return this.http.get(
      `${this.baseUrl}/get_tpr_consensus_summary?ticker=${ticker}`,
    );
  };

  getRatingConsensus = (ticker: string): Observable<any> => {
    return this.http.get(
      `${this.baseUrl}/get_tpr_consensus_summary?ticker=${ticker}&add_sell_side=true`,
    );
  };

  getTargetPriceConsensus = (ticker: string): Observable<any> => {
    return this.http.get(
      `${this.baseUrl}/get_target_price_consensus?ticker=${ticker}`,
    );
  };
}
